/*
 * Registry of all cache stores created by createCacheStore, so every cache
 * can be cleared at once (e.g. on logout — caches are session-only and
 * must never leak data across accounts). Stores register themselves in
 * the factory.
 */
const clearFnsByName = new Map<string, () => void>();

export const registerCacheClear = (name: string, clear: () => void): void => {
    clearFnsByName.set(name, clear);
};

export const clearAllCaches = (): void => {
    clearFnsByName.forEach((clear) => clear());
};
